// // // import React, { useState, useEffect,useRef } from "react";
// // // import AlertModal from "../components/AlertModal";
// // // import { MdEdit, MdDelete } from "react-icons/md";
// // // import {
// // //   GridComponent,
// // //   ColumnsDirective,
// // //   ColumnDirective,
// // //   Page,
// // //   Selection,
// // //   Inject,
// // //   Edit,
// // //   Toolbar,
// // //   Sort,
// // //   Filter,

// // // } from "@syncfusion/ej2-react-grids";
// // // import EditModal from "../components/EditModal";
// // // import DeleteConfirmationModal from "../components/DeleteConfirmationModal";
// // // import APKForm from "./APKForm";
// // // import { Header } from "../components";
// // // import { useStateContext } from "../contexts/ContextProvider";
// // // import { ToastContainer, toast } from 'react-toastify';
// // // import 'react-toastify/dist/ReactToastify.css';
// // // const API_URL=process.env.REACT_APP_API_URL_V;
// // // const APK = ({ subscriptionsData }) => {
// // //   const { currentColor } = useStateContext();
// // //   const [isFormVisible, setIsFormVisible] = useState(false);
// // //   const [APKData, setAPKData] = useState([]);
// // //   const [isEditModalOpen, setIsEditModalOpen] = useState(false);
// // //   const [selectedData, setSelectedData] = useState(null);
// // //   const [uidToDelete, setUidToDelete] = useState(null);
// // //   const [showDeleteModal, setShowDeleteModal] = useState(false);
// // //   const [modalMessage, setModalMessage] = useState("");
// // //   const [showModal, setShowModal] = useState(false);
// // //   const toolbarOptions = ["Search"];

// // //   const [formData, setFormData] = useState({
// // //     ...APKData,
// // //     ...subscriptionsData,
// // //   });

// // //   console.log(subscriptionsData);
// // //   const accessToken = localStorage.getItem("accesstoken");
// // //   const fetchDataFromApkMaster = async () => {
// // //     try {
// // //       const response = await fetch( `${API_URL}/apkmaster`, {
// // //         method: "GET",
// // //         headers: {
// // //           "Content-Type": "application/json",
// // //           "x-auth-token": accessToken,
// // //         },
// // //       });

// // //       if (!response.ok) {
// // //         throw new Error("Failed to fetch data");
// // //       }

// // //       const data = await response.json();
// // //       setAPKData(data.data);
// // //     } catch (error) {
// // //       console.error("Error fetching data:", error);
// // //     }
// // //   };

// // //   const handleFormSubmit = (formData) => {
// // //     setAPKData([...APKData, formData]);
// // //     setIsFormVisible(false);
// // //     console.log("APK form submitted");
// // //   };

// // //   const handleEditButtonClick = (rowData) => {
// // //     setSelectedData(rowData);
// // //     setIsEditModalOpen(true);
// // //   };

// // //   // const handleDeleteButtonClick = async (rowData) => {
// // //   //   console.log(subscriptionsData, "8888888");

// // //   //   console.log("rowData._id", rowData);
// // //   //   console.log("apk", APKData);
// // //   //   console.log("subData", subscriptionsData);

// // //   //   if (subscriptionsData.includes(rowData._id)) {
// // //   //     alert("This APK is mapped to a tenant and cannot be deleted.");
// // //   //   } else {
// // //   //     setUidToDelete(rowData.uid);
// // //   //     setShowDeleteModal(true);
// // //   //   }
// // //   // };
// // //   const handleDeleteButtonClick = async (rowData) => {
// // //     console.log("rowData",rowData)

// // //     try {

// // //       if (subscriptionsData.includes(rowData._id)) {
// // //         setModalMessage("This APK is mapped to a tenant and cannot be deleted.");
// // //         setShowModal(true);
// // //       } else {
// // //         setUidToDelete(rowData.uid);
// // //         setShowDeleteModal(true);
// // //       }
// // //     } catch (error) {
// // //       console.error("Error fetching/updating subscriptionsData:", error);
// // //     }
// // //   };

// // //   const handleModalClose = () => {
// // //     setShowModal(false);
// // //     setModalMessage("");
// // //   };

// // //   const handleConfirmDelete = async (uid) => {
// // //     try {
// // //       const response = await fetch(
// // //          `${API_URL}/apkMaster/${uid}`,
// // //         {
// // //           method: "PUT",
// // //           headers: {
// // //             "Content-Type": "application/json",
// // //             "x-auth-token": accessToken,
// // //           },
// // //           body: JSON.stringify({ status: "inactive" }),
// // //         }
// // //       );

// // //       if (response.ok) {
// // //         const updatedData = APKData.filter((apk) => apk.uid !== uid);
// // //         setAPKData(updatedData);
// // //         console.log(`APK with UID ${uid} deleted successfully`);
// // //         fetchDataFromApkMaster();
// // //         const existingApk = APKData.find((apk) => apk.uid === uidToDelete);
// // //         if (existingApk.status === 'inactive') {
// // //         toast.info('Status is already inactive', {
// // //           position: 'bottom-right',
// // //           autoClose: 3000,
// // //           hideProgressBar: false,
// // //           closeOnClick: true,
// // //           pauseOnHover: true,
// // //           draggable: true,
// // //           progress: undefined,
// // //         });
// // //         return;
// // //       }
// // //         toast.success('Status changed to inactive successfully', {
// // //           position: 'bottom-right',
// // //           autoClose: 3000,
// // //           hideProgressBar: false,
// // //           closeOnClick: true,
// // //           pauseOnHover: true,
// // //           draggable: true,
// // //           progress: undefined,
// // //         });
// // //       } else {
// // //         throw new Error("Failed to delete APK");
// // //       }
// // //     } catch (error) {
// // //       console.error("Error deleting APK:", error);
// // //       toast.error('Error deleting APK', {
// // //         position: 'bottom-right',
// // //         autoClose: 3000,
// // //         hideProgressBar: false,
// // //         closeOnClick: true,
// // //         pauseOnHover: true,
// // //         draggable: true,
// // //         progress: undefined,
// // //       });
// // //     }
// // //     setShowDeleteModal(false);
// // //   };

// // //   // const updatedApkData = APKData.map((apk) => ({
// // //   //   ...apk,
// // //   //   apksids: subscriptionsData.includes(apk._id) ? subscriptionsData : [],
// // //   // }));

// // //   useEffect(() => {
// // //   console.log("Initial subscriptionsData:", subscriptionsData);
// // //   fetchDataFromApkMaster();
// // // }, []);

// // //   useEffect(() => {
// // //     setFormData({
// // //       ...APKData,
// // //       ...subscriptionsData,
// // //     });
// // //   }, [APKData, subscriptionsData]);
// // //   console.log("formData");
// // //   // console.log("Updated Apk Data:", updatedApkData);

// // //   return (
// // //     <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
// // //       <style>
// // //         {`
// // //           .e-grid .e-headercell .e-headertext {
// // //             font-weight: bold;
// // //             font-size: 14px;
// // //           }

// // //           .status-dot-container {
// // //             display: flex;
// // //             align-items: center;
// // //           }

// // //           .status-dot {
// // //             width: 9px;
// // //             height: 9px;
// // //             border-radius: 50%;
// // //             margin-right: 5px;
// // //             display: inline-block;
// // //           }

// // //           .status-dot.active {
// // //             background-color: green; // Adjust the color for active status
// // //           }

// // //           .status-dot.inactive {
// // //             background-color: red; // Adjust the color for inactive status
// // //           }
// // //         `}
// // //       </style>
// // //       <div className="flex justify-between items-center mb-4">
// // //         <Header title="APK" />
// // //         <div className="flex items-center">
// // //           <button
// // //             className="my-0 item-center flex justify-center p-2 rounded-full tracking-wide focus:outline-none focus:shadow-outline shadow-lg cursor-pointer font-bold py-2 px-4"
// // //             style={{ backgroundColor: currentColor, color: "white" }}
// // //             onClick={() => setIsFormVisible(true)}
// // //           >
// // //             Create
// // //           </button>
// // //         </div>
// // //       </div>

// // //       {isFormVisible && (
// // //          <div className=" relative z-50 ">
// // //         <APKForm
// // //         fetchDataFromApkMaster={fetchDataFromApkMaster}
// // //           onSubmit={handleFormSubmit}
// // //           onCloseForm={() => setIsFormVisible(false)}
// // //         />
// // //         </div>
// // //       )}

// // //       {isEditModalOpen && selectedData && (
// // //          <div className=" relative z-50 ">
// // //         <EditModal
// // //         fetchDataFromApkMaster={fetchDataFromApkMaster}
// // //           data={selectedData}
// // //           onClose={() => setIsEditModalOpen(false)}
// // //           setIsEditModalOpen={setIsEditModalOpen}
// // //         />
// // //         </div>
// // //       )}

// // //       {showDeleteModal && (
// // //         <DeleteConfirmationModal
// // //           uidToDelete={uidToDelete}
// // //           onClose={() => setShowDeleteModal(false)}
// // //           onDelete={handleConfirmDelete}
// // //         />
// // //       )}

// // //       {showModal && (
// // //         <AlertModal message={modalMessage} onClose={handleModalClose} />
// // //       )}
// // //       <div className=" relative z-0 ">
// // //       <GridComponent
// // //           dataSource={APKData}
// // //           allowPaging
// // //           pageSettings={{ pageCount: 5, pageSize: 10 }}
// // //           selectionSettings={{ persistSelection: true }}
// // //           allowSorting
// // //           toolbar={toolbarOptions}
// // //         >
// // //           <ColumnsDirective>
// // //             <ColumnDirective field="name" headerText="Apk Name" textAlign="Left" />
// // //             <ColumnDirective
// // //               field="status"
// // //               headerText="Status"
// // //               textAlign="Left"
// // //               template={(rowData) => (
// // //                 <div className="status-dot-container">
// // //                   <span
// // //                     className={`status-dot ${
// // //                       rowData.status === "active" ? "active" : "inactive"
// // //                     }`}
// // //                   ></span>
// // //                   {rowData.status}
// // //                 </div>
// // //               )}
// // //             />
// // //             <ColumnDirective
// // //               headerText="Action"
// // //               width="150"
// // //               textAlign="Left"
// // //               template={(rowData) => (
// // //                 <div className="action-buttons">
// // //                   <button
// // //                     title="Edit"
// // //                     className="e-btn e-flat e-Tertiary e-small e-icon-btn edit-button"
// // //                     onClick={() => handleEditButtonClick(rowData)}
// // //                   >
// // //                     <MdEdit />
// // //                   </button>
// // //                   <button
// // //                     title="Delete"
// // //                     className="e-btn e-flat e-Tertiary e-small e-icon-btn delete-button"
// // //                     onClick={() => {
// // //                       handleDeleteButtonClick(rowData);
// // //                     }}
// // //                   >
// // //                     <MdDelete />
// // //                   </button>
// // //                 </div>
// // //               )}
// // //             />
// // //           </ColumnsDirective>
// // //           <Inject services={[Page, Selection, Toolbar, Edit, Sort, Filter]} />
// // //         </GridComponent>
// // //       </div>

// // //       <ToastContainer/>
// // //     </div>
// // //   );
// // // };

// // // export default APK;
// // //import React, { useState, useEffect } from "react";
// import React, { useState, useEffect } from "react";
// import { MdEdit, MdDelete, MdCloudDownload } from "react-icons/md";
// import {
//   GridComponent,
//   ColumnsDirective,
//   ColumnDirective,
//   Page,
//   Selection,
//   Inject,
//   Edit,
//   Toolbar,
//   Sort,
//   Filter,
// } from "@syncfusion/ej2-react-grids";
// import { Header } from "../components";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import APKForm from "./APKForm";
// import EditModal from "../components/EditModal";
// import AlertModal from "../components/AlertModal";
// import DeleteConfirmationModal from "../components/DeleteConfirmationModal";
// import { useStateContext } from "../contexts/ContextProvider";

// const API_URL = process.env.REACT_APP_API_URL_V;

// const APK = ({ subscriptionsData }) => {
//   const { currentColor } = useStateContext();
//   const [isFormVisible, setIsFormVisible] = useState(false);
//   const [APKData, setAPKData] = useState([]);
//   const [isEditModalOpen, setIsEditModalOpen] = useState(false);
//   const [selectedData, setSelectedData] = useState(null);
//   const [uidToDelete, setUidToDelete] = useState(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [modalMessage, setModalMessage] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const toolbarOptions = ["Search"];

//   const accessToken = localStorage.getItem("accesstoken");

//   const fetchDataFromApkMaster = async () => {
//     try {
//       const response = await fetch(`${API_URL}/apkmaster`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           "x-auth-token": accessToken,
//         },
//       });

//       if (!response.ok) {
//         throw new Error("Failed to fetch data");
//       }

//       const data = await response.json();
//       setAPKData(data.data);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const handleFormSubmit = (formData) => {
//     setAPKData([...APKData, formData]);
//     setIsFormVisible(false);
//     console.log("APK form submitted");
//   };

//   const handleEditButtonClick = (rowData) => {
//     setSelectedData(rowData);
//     setIsEditModalOpen(true);
//   };

//   const handleDeleteButtonClick = async (rowData) => {
//     try {
//       if (subscriptionsData.includes(rowData._id)) {
//         setModalMessage("This APK is mapped to a tenant and cannot be deleted.");
//         setShowModal(true);
//       } else {
//         setUidToDelete(rowData.uid);
//         setShowDeleteModal(true);
//       }
//     } catch (error) {
//       console.error("Error fetching/updating subscriptionsData:", error);
//     }
//   };

//   const handleModalClose = () => {
//     setShowModal(false);
//     setModalMessage("");
//   };

//   const handleConfirmDelete = async (uid) => {
//     try {
//       const response = await fetch(`${API_URL}/apkMaster/${uid}`, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           "x-auth-token": accessToken,
//         },
//         body: JSON.stringify({ status: "inactive" }),
//       });

//       if (response.ok) {
//         const updatedData = APKData.filter((apk) => apk.uid !== uid);
//         setAPKData(updatedData);
//         console.log(`APK with UID ${uid} deleted successfully`);
//         fetchDataFromApkMaster();
//         const existingApk = APKData.find((apk) => apk.uid === uidToDelete);
//         if (existingApk.status === "inactive") {
//           toast.info("Status is already inactive", {
//             position: "bottom-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//             progress: undefined,
//           });
//           return;
//         }
//         toast.success("Status changed to inactive successfully", {
//           position: "bottom-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//         });
//       } else {
//         throw new Error("Failed to delete APK");
//       }
//     } catch (error) {
//       console.error("Error deleting APK:", error);
//       toast.error("Error deleting APK", {
//         position: "bottom-right",
//         autoClose: 3000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//       });
//     }
//     setShowDeleteModal(false);
//   };

//   const handleDownloadButtonClick = async (apkKey) => {
//     try {
//       const response = await fetch(`${API_URL}/download/${apkKey}`);
//       if (!response.ok) {
//         throw new Error('Failed to generate signed URL');
//       }
//       const { signedUrl } = await response.json();

//       // Create an anchor element
//       const a = document.createElement("a");
//       a.href = signedUrl;
//       a.download = apkKey; // Set the download attribute to the APK file name
//       a.click();
//       toast.success("APK downloaded successfully");
//     } catch (error) {
//       console.error("Error downloading APK:", error);
//       toast.error("Failed to download APK");
//     }
//   };

//   useEffect(() => {
//     console.log("Initial subscriptionsData:", subscriptionsData);
//     fetchDataFromApkMaster();
//   }, []);

//   useEffect(() => {
//     // setFormData({
//     //   ...APKData,
//     //   ...subscriptionsData,
//     // });
//   }, [APKData, subscriptionsData]);

//   return (
//     <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
//       <style>
//         {`
//           .e-grid .e-headercell .e-headertext {
//             font-weight: bold;
//             font-size: 14px;
//           }

//           .status-dot-container {
//             display: flex;
//             align-items: center;
//           }

//           .status-dot {
//             width: 9px;
//             height: 9px;
//             border-radius: 50%;
//             margin-right: 5px;
//             display: inline-block;
//           }

//           .status-dot.active {
//             background-color: green; // Adjust the color for active status
//           }

//           .status-dot.inactive {
//             background-color: red; // Adjust the color for inactive status
//           }
//         `}
//       </style>
//       <div className="flex justify-between items-center mb-4">
//         <Header title="APK" />
//         <div className="flex items-center">
//           <button
//             className="my-0 item-center flex justify-center p-2 rounded-full tracking-wide focus:outline-none focus:shadow-outline shadow-lg cursor-pointer font-bold py-2 px-4"
//             style={{ backgroundColor: currentColor, color: "white" }}
//             onClick={() => setIsFormVisible(true)}
//           >
//             Create
//           </button>
//         </div>
//       </div>

//       {isFormVisible && (
//         <div className=" relative z-50 ">
//           <APKForm
//             fetchDataFromApkMaster={fetchDataFromApkMaster}
//             onSubmit={handleFormSubmit}
//             onCloseForm={() => setIsFormVisible(false)}
//           />
//         </div>
//       )}

//       {isEditModalOpen && selectedData && (
//         <div className=" relative z-50 ">
//           <EditModal
//             fetchDataFromApkMaster={fetchDataFromApkMaster}
//             data={selectedData}
//             onClose={() => setIsEditModalOpen(false)}
//             setIsEditModalOpen={setIsEditModalOpen}
//           />
//         </div>
//       )}

//       {showDeleteModal && (
//         <DeleteConfirmationModal
//           uidToDelete={uidToDelete}
//           onClose={() => setShowDeleteModal(false)}
//           onDelete={handleConfirmDelete}
//         />
//       )}

//       {showModal && <AlertModal message={modalMessage} onClose={handleModalClose} />}

//       <div className=" relative z-0 ">
//         <GridComponent
//           dataSource={APKData}
//           allowPaging
//           pageSettings={{ pageCount: 5, pageSize: 10 }}
//           selectionSettings={{ persistSelection: true }}
//           allowSorting
//           toolbar={toolbarOptions}
//         >
//           <ColumnsDirective>
//             <ColumnDirective field="name" headerText="Apk Name" textAlign="Left" />
//             <ColumnDirective
//               field="status"
//               headerText="Status"
//               textAlign="Left"
//               template={(rowData) => (
//                 <div className="status-dot-container">
//                   <span
//                     className={`status-dot ${rowData.status === "active" ? "active" : "inactive"}`}
//                   ></span>
//                   {rowData.status}
//                 </div>
//               )}
//             />
//             <ColumnDirective
//               headerText="Action"
//               width="200"
//               textAlign="Left"
//               template={(rowData) => (
//                 <div className="action-buttons">
//                   <button
//                     title="Edit"
//                     className="e-btn e-flat e-Tertiary e-small e-icon-btn edit-button"
//                     onClick={() => handleEditButtonClick(rowData)}
//                   >
//                     <MdEdit />
//                   </button>
//                   <button
//                     title="Delete"
//                     className="e-btn e-flat e-Tertiary e-small e-icon-btn delete-button"
//                     onClick={() => handleDeleteButtonClick(rowData)}
//                   >
//                     <MdDelete />
//                   </button>
//                   <button
//                     title="Download"
//                     className="e-btn e-flat e-Tertiary e-small e-icon-btn"
//                     onClick={() => handleDownloadButtonClick(rowData)}
//                   >
//                     <MdCloudDownload />
//                   </button>
//                 </div>
//               )}
//             />
//           </ColumnsDirective>
//           <Inject services={[Page, Selection, Toolbar, Edit, Sort, Filter]} />
//         </GridComponent>
//       </div>

//       <ToastContainer />
//     </div>
//   );
// };

// export default APK;
// //APK.js

import React, { useState, useEffect } from "react";
import { MdEdit, MdDelete, MdCloudDownload } from "react-icons/md";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Selection,
  Inject,
  Edit,
  Toolbar,
  Sort,
  Filter,
} from "@syncfusion/ej2-react-grids";
import { Header } from "../components";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import APKForm from "./APKForm";
import EditModal from "../components/EditModal";
import AlertModal from "../components/AlertModal";
import DeleteConfirmationModal from "../components/DeleteConfirmationModal";
import { useStateContext } from "../contexts/ContextProvider";

const API_URL = process.env.REACT_APP_API_URL_V;

const APK = ({ subscriptionsData }) => {
  const { currentColor } = useStateContext();
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [APKData, setAPKData] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [uidToDelete, setUidToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const toolbarOptions = ["Search"];

  const accessToken = localStorage.getItem("accesstoken");

  const fetchDataFromApkMaster = async () => {
    try {
      const response = await fetch(`${API_URL}/apkmaster`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": accessToken,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      setAPKData(data.data);
      console.log(data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleFormSubmit = (formData) => {
    setAPKData([...APKData, formData]);
    setIsFormVisible(false);
    console.log("APK form submitted");
  };

  const handleEditButtonClick = (rowData) => {
    setSelectedData(rowData);
    setIsEditModalOpen(true);
  };

  const handleDeleteButtonClick = async (rowData) => {
    try {
      if (subscriptionsData.includes(rowData._id)) {
        setModalMessage(
          "This APK is mapped to a tenant and cannot be deleted."
        );
        setShowModal(true);
      } else {
        setUidToDelete(rowData.uid);
        setShowDeleteModal(true);
      }
    } catch (error) {
      console.error("Error fetching/updating subscriptionsData:", error);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setModalMessage("");
  };

  const handleConfirmDelete = async (uid) => {
    try {
      const response = await fetch(`${API_URL}/apkMaster/${uid}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": accessToken,
        },
        body: JSON.stringify({ status: "inactive" }),
      });

      if (response.ok) {
        const updatedData = APKData.filter((apk) => apk.uid !== uid);
        setAPKData(updatedData);
        console.log(`APK with UID ${uid} deleted successfully`);
        fetchDataFromApkMaster();
        const existingApk = APKData.find((apk) => apk.uid === uidToDelete);
        if (existingApk.status === "inactive") {
          toast.info("Status is already inactive", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          return;
        }
        toast.success("Status changed to inactive successfully", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        throw new Error("Failed to delete APK");
      }
    } catch (error) {
      console.error("Error deleting APK:", error);
      toast.error("Error deleting APK", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setShowDeleteModal(false);
  };

  // const handleDownloadButtonClick = async (filename) => {
  //   console.log("Downloading APK with filename:", filename);
  //   try {
  //     if (!filename) {
  //       throw new Error("Filename is undefined");
  //     }

  //     const response = await fetch(`${API_URL}/download/${filename}`);
  //     if (!response.ok) {
  //       throw new Error("Failed to download APK");
  //     }
  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = filename;
  //     document.body.appendChild(a);
  //     a.click();
  //     window.URL.revokeObjectURL(url);
  //     a.remove();
  //     toast.success("APK downloaded successfully", {
  //       position: toast.POSITION.BOTTOM_RIGHT,
  //       autoClose: 3000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //     });
  //   } catch (error) {
  //     console.error("Error downloading APK:", error);
  //     toast.error("Failed to download APK");
  //   }
  // };

  const handleDownloadButtonClick = async (filename) => {
    console.log("Downloading APK with filename:", filename);
    try {
      if (!filename) {
        throw new Error("Filename is undefined");
      }
  
      // Display a toast indicating that the download is in progress
      toast.info("Downloading APK...", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: false, // Don't close automatically, will be closed after success or failure
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
  
      const response = await fetch(`${API_URL}/download/${filename}`);
      if (!response.ok) {
        throw new Error("Failed to download APK");
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      
      // Close the previous toast indicating download in progress
      toast.dismiss();
  
      // Display a success toast message
      toast.success("APK downloaded successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      console.error("Error downloading APK:", error);
      toast.error("Failed to download APK", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  
  useEffect(() => {
    console.log("Initial subscriptionsData:", subscriptionsData);
    fetchDataFromApkMaster();
  }, []);

  useEffect(() => {
    // setFormData({
    //   ...APKData,
    //   ...subscriptionsData,
    // });
  }, [APKData, subscriptionsData]);

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <style>
        {`
          .e-grid .e-headercell .e-headertext {
            font-weight: bold;
            font-size: 14px;
          }

          .status-dot-container {
            display: flex;
            align-items: center;
          }

          .status-dot {
            width: 9px;
            height: 9px;
            border-radius: 50%;
            margin-right: 5px;
            display: inline-block;
          }

          .status-dot.active {
            background-color: green; // Adjust the color for active status
          }

          .status-dot.inactive {
            background-color: red; // Adjust the color for inactive status
          }
        `}
      </style>
      <div className="flex justify-between items-center mb-4">
        <Header title="APK" />
        <div className="flex items-center">
          <button
            className="my-0 item-center flex justify-center p-2 rounded-full tracking-wide focus:outline-none focus:shadow-outline shadow-lg cursor-pointer font-bold py-2 px-4"
            style={{ backgroundColor: currentColor, color: "white" }}
            onClick={() => setIsFormVisible(true)}
          >
            Create
          </button>
        </div>
      </div>

      {isFormVisible && (
        <div className=" relative z-50 ">
          <APKForm
            fetchDataFromApkMaster={fetchDataFromApkMaster}
            onSubmit={handleFormSubmit}
            onCloseForm={() => setIsFormVisible(false)}
          />
        </div>
      )}

      {isEditModalOpen && selectedData && (
        <div className=" relative z-50 ">
          <EditModal
            fetchDataFromApkMaster={fetchDataFromApkMaster}
            data={selectedData}
            onClose={() => setIsEditModalOpen(false)}
            setIsEditModalOpen={setIsEditModalOpen}
          />
        </div>
      )}

      {showDeleteModal && (
        <DeleteConfirmationModal
          uidToDelete={uidToDelete}
          onClose={() => setShowDeleteModal(false)}
          onDelete={handleConfirmDelete}
        />
      )}

      {showModal && (
        <AlertModal message={modalMessage} onClose={handleModalClose} />
      )}

      <div className=" relative z-0 ">
        <GridComponent
          dataSource={APKData}
          allowPaging
          pageSettings={{ pageCount: 5, pageSize: 10 }}
          selectionSettings={{ persistSelection: true }}
          allowSorting
          toolbar={toolbarOptions}
        >
          <ColumnsDirective>
            <ColumnDirective
              field="name"
              headerText="Apk Name"
              textAlign="Left"
            />
            <ColumnDirective
              field="status"
              headerText="Status"
              textAlign="Left"
              template={(rowData) => (
                <div className="status-dot-container">
                  <span
                    className={`status-dot ${
                      rowData.status === "active" ? "active" : "inactive"
                    }`}
                  ></span>
                  {rowData.status}
                </div>
              )}
            />
            <ColumnDirective
              headerText="Action"
              width="200"
              textAlign="Left"
              template={(rowData) => (
                <div className="action-buttons">
                  <button
                    title="Edit"
                    className="e-btn e-flat e-Tertiary e-small e-icon-btn edit-button"
                    onClick={() => handleEditButtonClick(rowData)}
                  >
                    <MdEdit />
                  </button>
                  <button
                    title="Delete"
                    className="e-btn e-flat e-Tertiary e-small e-icon-btn delete-button"
                    onClick={() => handleDeleteButtonClick(rowData)}
                  >
                    <MdDelete />
                  </button>
                  <button
                    title="Download"
                    className="e-btn e-flat e-Tertiary e-small e-icon-btn"
                    onClick={() => handleDownloadButtonClick(rowData.file.key)}
                  >
                    <MdCloudDownload />
                  </button>
                </div>
              )}
            />
          </ColumnsDirective>
          <Inject services={[Page, Selection, Toolbar, Edit, Sort, Filter]} />
        </GridComponent>
      </div>

      <ToastContainer />
    </div>
  );
};

export default APK;
